/**
 * Ryan O'Dowd
 * 2023-05-29
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: { // @TODO: looks like there's still horizonal margin or padding on home screen passages
      width: '100%',
    },
    mainListContainer: {
      width: '100%',
      paddingHorizontal: 6,
      paddingTop: 12,
      paddingBottom: 8,
    },
    extraBottomPadding: { // @TODO: not a fan of hardcoding SelectionMenu's (approximate) height
      paddingBottom: 44 + 8,
    },
    // @TODO: abstract these with components/Passage
    versesWrapper: {
      // @TODO: display: 'flex',
      paddingTop: 0,
      marginBotton: 0,
      paddingBottom: 0,
    },
    numsOnlyVersesWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
    },
    spacer: { // this is for short chapters...make sure licensing is at the bottom of the screen
      display: 'flex',
      flexGrow: 1,
    },
    licenseWrapper: {
      display: 'flex',
      marginTop: 16,
    },
  };
};

export default getStyles;
